import { Injectable } from '@angular/core';
import { UrlConnectionEnum } from 'src/app/enums/connection/url-connection.enum';
import { HttpService } from '../http-service/http.service';

@Injectable({
    providedIn: 'root'
})
export class ActivationListService {

    constructor(private httpService: HttpService) { }

    /**
     * Gets activation list
     * @author Starley Cazorla
     * @param configData
     * @returns
     */
    async getActivationList(configData: any) {
        return new Promise((resolve, reject) => {
            try {

                let config = this.httpService.setHeaderConfig(true);

                this.httpService.get(UrlConnectionEnum.GET_ACTIVATION_LIST, configData, config).subscribe(
                    {
                        next: (data) => {
                            resolve(data);
                        },
                        error: (error) => {
                            reject(error);
                        }
                    });

            } catch (error) {
                reject(error);
            }
        });
    }

}
